import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";

function FerryTipsContent() {
    const title = useTranslation(`${singleModalTranslationKey}.ferries.title`)
    const {
        title: subtitle,
        o1,
        o2,
        o3,
    } = useTranslation(`${singleModalTranslationKey}.ferries.tips`)

    return (
        <TipsPerTransportType
            title={title}
            subtitle={subtitle}
            options={[
                {id: "ferry-o1", option: o1},
                {id: "ferry-o2", option: o2},
                {id: "ferry-o3", option: o3},
            ]}
        />
    )
}

export default FerryTipsContent